import { AgGridFilterOption } from 'core/enums';
import { QuoteEntityType, QuoteState } from 'quotes/enums';

export const getInitialState = (entityType = QuoteEntityType.QUOTE) => {
  switch (entityType) {
    case QuoteEntityType.ORDER:
      return {
        filter: {
          filterModel: {
            createdAt: {
              filterType: 'date',
              type: AgGridFilterOption.RELATIVE_LAST_30_DAYS,
            },
          },
        },
      };
    case QuoteEntityType.QUOTE:
    default:
      return {
        filter: {
          filterModel: {
            archived: { filterType: 'set', values: [QuoteState.ACTIVE] },
            updatedAt: {
              filterType: 'date',
              type: AgGridFilterOption.RELATIVE_LAST_90_DAYS,
            },
          },
        },
      };
  }
};
